var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragAndDropHandleIcon = function SvgDragAndDropHandleIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5C7.17125 5.5 6.5 4.82875 6.5 4C6.5 3.17125 7.17125 2.5 8 2.5C8.82875 2.5 9.5 3.17125 9.5 4C9.5 4.82875 8.82875 5.5 8 5.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5C15.1712 5.5 14.5 4.82875 14.5 4C14.5 3.17125 15.1712 2.5 16 2.5C16.8288 2.5 17.5 3.17125 17.5 4C17.5 4.82875 16.8288 5.5 16 5.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C7.17125 13.5 6.5 12.8288 6.5 12C6.5 11.1712 7.17125 10.5 8 10.5C8.82875 10.5 9.5 11.1712 9.5 12C9.5 12.8288 8.82875 13.5 8 13.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5C15.1712 13.5 14.5 12.8288 14.5 12C14.5 11.1712 15.1712 10.5 16 10.5C16.8288 10.5 17.5 11.1712 17.5 12C17.5 12.8288 16.8288 13.5 16 13.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.5C7.17125 21.5 6.5 20.8288 6.5 20C6.5 19.1712 7.17125 18.5 8 18.5C8.82875 18.5 9.5 19.1712 9.5 20C9.5 20.8288 8.82875 21.5 8 21.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5C15.1712 21.5 14.5 20.8288 14.5 20C14.5 19.1712 15.1712 18.5 16 18.5C16.8288 18.5 17.5 19.1712 17.5 20C17.5 20.8288 16.8288 21.5 16 21.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragAndDropHandleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "02058e077a25d9cbd1dbc6996d1b7bbf.svg";